<script>
  import OtherCities from "@src/sections/OtherCities/Prose.svelte";
  import Rankings from "@src/sections/Rankings/Prose.svelte";
  import Blocks from "@src/sections/Blocks/Prose.svelte";
  import Outcomes from "@src/sections/Outcomes/Prose.svelte";
  import OutcomesStatic from "@src/sections/Outcomes/ProseStatic.svelte";
  import AboutFunds from "@src/sections/AboutFunds/Prose.svelte";
  import TreemapInContext from "@src/sections/TreemapInContext/Prose.svelte";
  import TreemapPlaceholder from "@src/sections/Treemap/TreemapPlaceholder.svelte";
  import Lead from "@src/sections/Lead.svelte";
  import Share from "@src/sections/Share/Prose.svelte";
  import Footer from "@src/sections/Footer.svelte";

  import BlurContainer from "@helpers/BlurContainer.svelte";

  import {
    topFourDepartments,
    budgetBlocks,
    selectedPerformanceMeasures,
  } from "@stores/userData.js";
</script>

<Lead />
<OtherCities />
<AboutFunds />
<Rankings />

<BlurContainer blurred={$topFourDepartments.length == 0}>
  <Outcomes />
  <Blocks />
</BlurContainer>

<BlurContainer blurred={$budgetBlocks.length == 0}>
  <div style="display: {$budgetBlocks.length == 0 ? 'block' : 'none'}">
    <TreemapPlaceholder />
  </div>
  {#if $budgetBlocks.length > 0}
    <TreemapInContext />
  {/if}
  <OutcomesStatic />
</BlurContainer>

<BlurContainer
  blurred={$selectedPerformanceMeasures.length == 0 ||
    $budgetBlocks.length == 0}
>
  <Share />
  <Footer />
</BlurContainer>
